import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
const claimExternalWorkersService = {
  all(claimId) {
    return fetch(`/api/claims/${claimId}/claim_external_workers`, request.get);
  },
  get(claimExternalWorker) {
    return fetch(`/api/claims/${claimExternalWorker.claim_id}/claim_external_workers/${claimExternalWorker.id}`, request.get);
  },
  delete(claimExternalWorker) {
    return fetch(`/api/claims/${claimExternalWorker.claim_id}/claim_external_workers/${claimExternalWorker.id}`, request.delete);
  },
  update(claimExternalWorker) {
    return fetch(`/api/claims/${claimExternalWorker.claim_id}/claim_external_workers/${claimExternalWorker.id}`, {
      ...request.put,
      body: JSON.stringify({
        claim_external_worker: claimExternalWorker
      })
    });
  },
  create(claimExternalWorker) {
    return fetch(`/api/claims/${claimExternalWorker.claim_id}/claim_external_workers`, {
      ...request.post,
      body: JSON.stringify({
        claim_external_worker: claimExternalWorker
      })
    });
  }
};
export default claimExternalWorkersService;